export default __webpack_public_path__ + "static/media/Brown Bear.724c0767.jpg";